/** New Journey brand constants — use BRAND_SHORT (NJ) in compact UI slots. */
export const BRAND_NAME = "New Journey";
export const BRAND_SHORT = "NJ";
export const BRAND_STUDIO = "New Journey Studio";
export const BRAND_TAGLINE = "Premium 3D Printed Collectibles";
export const BRAND_WEBSITE = "https://store.newjourneyofficial.com";
export const BRAND_ADDRESS = "New Journey Studio, India";
export const BRAND_PHONE = "+91 9834093361";
export const BRAND_PHONE_RAW = "9834093361";
export const BRAND_GSTIN = "GSTIN: 29XXXXX0000X1ZX";
export const BRAND_EMAIL_HELLO = "newjourneyofficial1@gmail.com";
export const BRAND_UPI_ID = "tareaditya08-1@oksbi";
export const BRAND_EMAIL_PRIVACY = "privacy@newjourney.com";
export const BRAND_EMAIL_ADMIN = "admin@newjourney.com";
export const BRAND_EMAIL_CUSTOMER = "customer@newjourney.com";
